import * as yup from "yup";

export const docuementUploadSchmea = yup.object().shape({
  type: yup.string().required("Document type is required"),
});
